import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '../../core/authentication';

@Component({
  selector: 'app-productselect',
  templateUrl: './productselect.component.html',
  styleUrls: ['./productselect.component.scss']
})
export class ProductselectComponent implements OnInit {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {}

  ngOnInit() {
  }

}
